import { render } from "./index.vue?vue&type=template&id=2964abc9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2964abc9&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=2964abc9&lang=css"
script.render = render
script.__scopeId = "data-v-2964abc9"
/* hot reload */
if (module.hot) {
  script.__hmrId = "2964abc9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2964abc9', script)) {
    api.reload('2964abc9', script)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2964abc9&scoped=true", () => {
    api.rerender('2964abc9', render)
  })

}

script.__file = "src/index.vue"

export default script